<h3>Decyzja</h3>
<div class='gov-card'>
  <div class='gov-card__body'>
    <ol>
      <li *ngFor='let shipment of shipments(); let i = index'>
        <div class='row'>
          <div class='col-md-4'>
            <app-label label='Data wpływu:'>
              {{ (shipment?.createdAt | date) || '-' }}
            </app-label>
            <br>
            <app-label label='Opłata:'>
              {{ (shipment?.amount | currency) || 'Nie dotyczy' }}
            </app-label>
          </div>
          <div class='col-md-3 d-flex align-items-center'>
            Dokument:
            <ul>
              <li *ngFor='let item of getDocuments(shipment); let i = index'>
                <a href='#'
                   [title]='"Pobierz " + item?.originalName'
                   (click)='onDownloadFile($event, item?.id, item?.originalName)'>
                  {{ item | attachmentName }}
                </a>
                <ng-container *ngIf='i !== getDocuments(shipment).length - 1'>,</ng-container>
              </li>
              <li *ngIf='!getDocuments(shipment)?.length'>
                -
              </li>
            </ul>
          </div>
          <div class='col-md-5 d-flex align-items-center justify-content-end'>
            <button *ngIf='!shipment?.completedPayment' [disabled]='!shipment?.amount || !canPay()'
                    type='button'
                    class='btn btn-primary'
                    [routerLink]='["../../../", "zaplac-online", shipment?.uuid]'>
              Zapłać online
            </button>
            <button *ngIf='shipment?.completedPayment as confirmation' type='button' class='btn btn-secondary'
                    (click)='downloadConfirmation(confirmation?.id || "")'>
              <i class='fa fa-download'></i>Pobierz potwierdzenie
            </button>
          </div>
        </div>
        <hr *ngIf='i !== (shipments().length - 1)'>
      </li>
    </ol>
  </div>
</div>
